// A single labeled macro progress bar (carbs / protein / fat). Clamps at 100% and
// recolors to --danger when over target (distinct from the fat bar's own --warn
// fill, so an overage is always visible). `color` is a CSS color string, e.g.
// "rgb(var(--accent-move))".
interface Props {
  label: string;
  value: number;
  target: number;
  color: string;
}

export function MacroBar({ label, value, target, color }: Props) {
  const pct = target > 0 ? Math.min(1, value / target) : 0;
  const over = target > 0 && value > target;
  return (
    <div>
      <div className="flex justify-between text-sm text-fg-muted mb-1">
        <span>{label}</span>
        <span className="tabular-nums">{Math.round(value)} / {target} g</span>
      </div>
      <div className="h-1.5 rounded-full bg-surface-strong overflow-hidden">
        <div
          className="h-full rounded-full transition-[width] duration-500"
          style={{ width: `${pct * 100}%`, background: over ? "rgb(var(--danger))" : color }}
        />
      </div>
    </div>
  );
}
